/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateQuickbooksVerificationKeyInput = {
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createQuickbooksVerificationKeyMutationVariables = {
    input: CreateQuickbooksVerificationKeyInput;
};
export type createQuickbooksVerificationKeyMutationResponse = {
    readonly createQuickbooksVerificationKey: {
        readonly key: string | null;
    } | null;
};
export type createQuickbooksVerificationKeyMutation = {
    readonly response: createQuickbooksVerificationKeyMutationResponse;
    readonly variables: createQuickbooksVerificationKeyMutationVariables;
};



/*
mutation createQuickbooksVerificationKeyMutation(
  $input: CreateQuickbooksVerificationKeyInput!
) {
  createQuickbooksVerificationKey(input: $input) {
    key
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateQuickbooksVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateQuickbooksVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createQuickbooksVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createQuickbooksVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createQuickbooksVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createQuickbooksVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createQuickbooksVerificationKeyMutation(\n  $input: CreateQuickbooksVerificationKeyInput!\n) {\n  createQuickbooksVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
(node as any).hash = '28ca01b35748cc020ac8b50cb99c4bed';
export default node;
